import Router from 'vue-router';
import Vue from 'vue';
import Layout from '@/pages/layout/index.vue';
import { Message } from 'element-ui';
import { loadLanguageAsync } from '@/lang/i18n';
Vue.use(Router);

const routes = [
    {
        path: '',
        name: '',
        meta: {
            name: '验证中转页面'
        },
        component: () =>
            import('@/pages/login/verification.vue') // 中转页
    },
    {
        path: '/logoutPage',
        name: 'logoutPage',
        meta: {
            name: '其他系统退出登录中转页面'
        },
        component: () =>
            import('@/pages/login/logoutPage.vue')
    },
    {
        path: '/purchaseVerification',
        name: 'purchaseVerification',
        meta: {
            name: 'purchase登录验证中转页面'
        },
        component: () =>
            import('@/pages/login/verification.vue') // 中转页
    },
    {
        path: '/home',
        name: 'home',
        meta: {
            name: '首页'
        },
        component: Layout,
        children: [
            {
                path: '/',
                name: 'homePage',
                component: () => import('@/pages/home/index.vue'),
                meta: {
                    name: 'homePage',
                }
            }, {
                path: '/menuPage',
                name: '/menuPage',
                component: () => import('@/pages/menuPage/index.vue'),
                meta: {
                    name: 'menuPage'
                }
            }, {
                path: '/purchase',
                name: '/purchase',
                component: () => import('@/pages/userPages/purchase.vue'),
                meta: {
                    name: 'purchase',
                }
            }, {
                path: '/cookie-policy',
                name: 'cookie-policy',
                component: () =>
                    import('@/pages/layout/cookiePolicy.vue'),
                meta: {
                    name: 'cookie-policy'
                }
            }, {
                path: '/consumption',
                name: 'consumption',
                component: () =>
                    import('@/pages/userPages/consumption.vue'),
                meta: {
                    name: 'Comcomsumptionsumption',
                    requiresAuth: true
                }
            }
        ]
    }
];

const router = new Router({
    // 默认hash，如果要求是history模式，线上nginx需要配置try_files
    base: window.__POWERED_BY_QIANKUN__ ? '/vue2app' : '/',
    mode: 'history',
    routes
});

// 重写push与replace，解决重复页面跳转报错
const originalReplace = Router.prototype.replace;
const originalPush = Router.prototype.push;

Router.prototype.push = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => {
        if (Router.isNavigationFailure(err)) {
            return err;
        }
        return Promise.reject(err)
    })
}

Router.prototype.replace = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch(err => {
        if (Router.isNavigationFailure(err)) {
            return err;
        }
        return Promise.reject(err)
    })
}
// 多语言配置
let LanguageLists = {
    zh_CN: {
        UnifiedUserCentre: '统一用户中心',
        LoginExpired: '登录状态已过期！',
        NotHavePermission: '你没有访问该页面的权限'
    },
    en_GB: {
        UnifiedUserCentre: 'Unified User Centre',
        LoginExpired: 'Login status has expired!！',
        NotHavePermission: 'You do not have permission to access this page'
    },
    fr_FR: {
        UnifiedUserCentre: `Centre d'utilisateurs unifié`,
        LoginExpired: 'Le statut de connexion a expiré !',
        NotHavePermission: `Vous n'avez pas la permission d'accéder à cette page.`
    },
    de_DE: {
        UnifiedUserCentre: 'Einheitliches Benutzerzentrum',
        LoginExpired: 'Anmeldestatus ist abgelaufen!',
        NotHavePermission: 'Sie haben keine Berechtigung, diese Seite zu besuchen.'
    },
    pt_BR: {
        UnifiedUserCentre: 'Centro Unificado de Usuários',
        LoginExpired: 'O status de login expirou!',
        NotHavePermission: 'Você não tem permissão para acessar esta página.'
    },
    nl_NL: {
        UnifiedUserCentre: 'Uniform Gebruikerscentrum',
        LoginExpired: 'Inlogstatus is verlopen!',
        NotHavePermission: 'Je hebt geen toegang tot deze pagina.'
    },
    es_ES: {
        UnifiedUserCentre: 'Centro Unificado de Usuarios',
        LoginExpired: '¡El estado de la sesión ha expirado!',
        NotHavePermission: 'No tienes permiso para acceder a esta página.'
    },
    it_IT: {
        UnifiedUserCentre: 'Centro Unificato degli Utenti',
        LoginExpired: 'Lo stato di accesso è scaduto!',
        NotHavePermission: 'Non hai il permesso di accedere a questa pagina.'
    },
    da_DK: {
        UnifiedUserCentre: 'Forenet brugercenter',
        LoginExpired: 'Loginstatus er udløbet!',
        NotHavePermission: 'Du har ikke tilladelse til at besøge denne side.'
    }
};
let langList = ['zh_CN', 'en_GB', 'fr_FR', 'de_DE', 'pt_BR', 'nl_NL', 'es_ES', 'it_IT', 'da_DK'];
router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');
    let userLang = (localStorage.getItem('lang') || navigator.language || navigator.userLanguage);
    userLang = userLang ? userLang.split('-').join('_') : 'en_GB';
    userLang = langList.includes(userLang) ? userLang : 'en_GB';
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token || token === '') {
            Message.error((LanguageLists[userLang])['LoginExpired']);
            next({
                path: from.path
            });
        } else {
            loadLanguageAsync(userLang).then(() => {
                next();
            })
        }
    } else {
        // 多语言配置
        loadLanguageAsync(userLang).then(() => {
            next();
        })
    }
})

export default router;



// export default routes;